// extracted by mini-css-extract-plugin
export default {"open-app":"_1vwalsk","openApp":"_1vwalsk","loader":"_1xnw8jt","text":"_14nkn37","empty-pic":"_1vn1pn8","emptyPic":"_1vn1pn8"};